<template>
	<div>
		<div class="row gutter-sm">
			<div class="col-xs-12 col-sm-12 q-mt-lg">
				<span class="q-headline text-weight-light">{{ $t('levels') }}</span>
			</div>

			<div class="col-12" v-for="(level, index) in levels" :key="level.id">
				<div class="row">
					<div class="col-xs-12 col-sm-4">
						<q-input 
							:float-label="$t('title')" 
							v-model="level.title"
							:error="$v.levels.$each[index].title.$error" 
						/>
					</div>

					<div class="col-xs-12 col-sm-4">
						<q-input
							:float-label="$t('multiplication_base')"
							type="number"
							v-model="level.multiplication_base"
						/>
					</div>

					<div class="col-xs-12 col-sm-4">
						<q-input
							:float-label="$t('points_to_acquire')"
							type="number"
							v-model="level.points_to_acquire"
							:error="$v.levels.$each[index].points_to_acquire.$error"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="positive"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
	name: 'Campaign-Levels',

	data() {
		return {
			levels: [
				{
					id: '',
					multiplication_base: '',
					order: '',
					points_to_acquire: '',
					slug: '',
					title: '',
				},
			],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id: 'campaigns/id',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_rewards/campaigns/${this.id}/levels/`, this.getHeader)
				.then((response) => {
					this.levels = response.data
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		async saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				let failed = false
				this.$q.loading.show()

				for (const level of this.levels) {
					const data = {
						points_to_acquire: level.points_to_acquire,
						title: level.title,
						multiplication_base: level.multiplication_base,
					}

					await this.$axios
						.put(
							`/admin_rewards/campaigns/${this.id}/levels/${level.id}/`,
							data,
							this.getHeader
						)
						.then(() => {})
						.catch((e) => {
							console.log(e)
							failed = true
						})
				}

				this.$q.loading.hide()

				if (failed) {
					this.$q.notify({
						message: this.$t('error_updating_levels'),
						type: 'negative',
						icon: 'fal fa-exclamation-triangle',
						position: 'top',
					})
				} else {
					this.$q.notify({
						message: this.$t('levels_updated_successfully'),
						type: 'positive',
						icon: 'fal fa-save',
						position: 'top',
					})
				}
			}
		},
	},

	created() {
		this.fetchData()
	},

	validations() {
		return {
			levels: {
				$each: {
					points_to_acquire: { required },
					title: { required }
				},
			},
		}
	},
}
</script>

<style></style>
